import { Injectable } from '@angular/core';
import { ActivatedRoute, QueryParamsHandling, Router } from '@angular/router';
import { params } from '@app/configurations';
import { Observable, Subject } from 'rxjs';
import { KeysChanges } from '../utilities/object.utilities';

@Injectable({ providedIn: 'root' })
export class StateService {
  counter = 0;
  prev = {};
  current = {};
  subject = new Subject<any>();

  get customerId(): number {
    return parseInt(this.getState()[params.CUSTOMER_ID]) || 0;
  }

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {}

  getPrevState() {
    return { ...this.prev };
  }

  getState() {
    return { ...this.current };
  }

  setState() {
    this.activatedRoute.queryParams.subscribe((data: any) => {
      if (this.counter > 0) {
        this.prev = { ...this.current };
        this.current = { ...data };
        this.subject.next({ current: { ...data }, prev: { ...this.prev } });
      }
      this.counter++;
    });
  }

  changeState(data: any, type = 'merge' as QueryParamsHandling, replaceUrl = false, updateCurrentState = false) {
    if (updateCurrentState) {
      for (const x in data) {
        if (data[x] == null) {
          delete data[x];
        }
      }
      this.current = { ...data };
    }

    return this.router.navigate([], {
      queryParamsHandling: type,
      queryParams: data,
      replaceUrl,
    });
  }

  navigateToRoute(queryParams: any, route: string) {
    this.router.navigate([route], {
      queryParamsHandling: 'merge',
      queryParams,
      replaceUrl: true,
    });
    this.current = { ...queryParams };
  }

  filterChanges(state: any, keys: string[], cb: (currentState: any, prevState?: any) => void) {
    if (KeysChanges(keys, state.current, state.prev)) cb(state.current, state.prev);
  }

  onChange(): Observable<any> {
    return this.subject.asObservable();
  }
}
